import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { withTracker } from 'meteor/react-meteor-data';
import { Meteor } from 'meteor/meteor';
import { Bert } from 'meteor/themeteorchef:bert';
import { isEmpty, isNil, isEqual } from 'lodash';

import Layers from '../../../api/Layers/Layers';
import Graphics from '../../../api/Graphics/Graphics';
import { getType, getLayerId } from '../../../api/Graphics/graphic-operations';

import loadTableLayer from '../../../modules/load-table-layer';
import { GRAPH_ELEMENTS } from '../../../modules/graphic-elements';
import getGraphicProps from '../../../modules/get-graphic-props';

import NotFound from '../NotFound';

import Loading from '../../components/Loading';

class PublicGraphic extends Component {
  state = {
    height: 0,
    width: 0,
    attributes: [],
    values: []
  };

  cardCol = React.createRef();

  async componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
    this.loadAttributes();
  }

  async componentDidUpdate(prevProps) {
    const { layer, loading, graphic } = this.props;
    const { layer: prevLayer, loading: prevLoading } = prevProps;

    if (prevLoading && !loading && !isEmpty(graphic)) {
      this.updateDimensions();
    }

    if (isEmpty(prevLayer) && !isEqual(layer, prevLayer)) {
      this.loadAttributes();
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  loadAttributes = async () => {
    const { layer } = this.props;
    try {
      const { tableBody, tableTitle } = await loadTableLayer(layer);

      this.setState({
        attributes: tableTitle,
        values: tableBody
      });
    } catch (error) {
      Bert.alert(error.message, 'danger');
    }
  };

  updateDimensions = () => {
    const { isAtlas } = this.props;
    if (!isAtlas) {
      this.setState({
        height: window.innerHeight,
        width: window.innerWidth
      });
    } else if (this.cardCol.current) {
      this.setState({
        height: this.cardCol.current.offsetHeight,
        width: this.cardCol.current.offsetWidth
      });
    }
  };

  render() {
    const { loading, graphic, atlasID, isAtlas } = this.props;
    const { attributes, values, height, width } = this.state;
    if (loading) return <Loading />;
    if (isEmpty(graphic)) return <NotFound />;

    const { value } = GRAPH_ELEMENTS.properties[getType(graphic)];

    const graphicProps = getGraphicProps({
      width,
      height,
      graphic,
      attributes,
      values,
      verticalPadding: false,
      aspectRatio: 1,
      isAtlas
    });
    const previewWithProps = React.cloneElement(value, { ...graphicProps, atlasID });

    return (
      <Row className={`h-100 ${isAtlas ? 'mx-0' : ''}`}>
        <Col xs={12} className="px-0 h-100" ref={this.cardCol}>
          {previewWithProps}
        </Col>
      </Row>
    );
  }
}

PublicGraphic.defaultProps = {
  graphic: {},
  layer: {},
  isAtlas: false,
  atlasID: ''
};

PublicGraphic.propTypes = {
  graphic: PropTypes.object,
  layer: PropTypes.object,
  isAtlas: PropTypes.bool,
  atlasID: PropTypes.string,
  loading: PropTypes.bool.isRequired
};

export default withTracker(({ match, privateShared }) => {
  if (privateShared) {
    const graphicPublicId = match.params.public_graphic_id;
    const graphicSub = Meteor.isClient && Meteor.subscribe('graphics.private', graphicPublicId);
    const graphic = Graphics.findOne({ publicId: graphicPublicId });
    if (!isNil(graphic)) {
      const layersSub = Meteor.isClient && Meteor.subscribe('layers.public');
      const layerId = getLayerId(graphic);
      return {
        loading: !Meteor.isClient || !layersSub.ready() || !graphicSub.ready(),
        layer: Layers.findOne(layerId),
        graphic
      };
    }
    return {
      loading: !Meteor.isClient || !graphicSub.ready()
    };
  }
  const graphicPublicId = match.params.public_graphic_id;
  const graphicSub = Meteor.isClient && Meteor.subscribe('graphics.public', graphicPublicId);
  const graphic = Graphics.findOne({ publicId: graphicPublicId });
  if (!isNil(graphic)) {
    const layersSub = Meteor.isClient && Meteor.subscribe('layers.public');
    const layerId = getLayerId(graphic);
    return {
      loading: !Meteor.isClient || !layersSub.ready() || !graphicSub.ready(),
      layer: Layers.findOne(layerId),
      graphic
    };
  }
  return {
    loading: !Meteor.isClient || !graphicSub.ready()
  };
})(PublicGraphic);
